import { useEffect, useState } from "react";
import { CalendarClock } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;

export function SlotPicker({ value, onChange, refreshKey }) {
  const [data, setData] = useState(null);
  const [dayIdx, setDayIdx] = useState(0);

  useEffect(() => {
    fetch(`${API}/api/slots`)
      .then((r) => r.json())
      .then(setData)
      .catch(() => setData({ days: [] }));
  }, [refreshKey]);

  if (!data) return <p className="text-sm text-ink-muted" data-testid="slot-picker-loading">Loading times…</p>;
  if (!data.days.length) return <p className="text-sm text-ink-muted">No open times right now. Leave your email and we&apos;ll reach out.</p>;

  const day = data.days[Math.min(dayIdx, data.days.length - 1)];

  return (
    <div className="rounded-2xl border border-border bg-surface-elevated p-4 text-left" data-testid="slot-picker">
      <p className="flex items-center gap-2 text-sm font-semibold text-navy">
        <CalendarClock size={16} className="text-brand" /> Pick a demo time
        <span className="ml-auto text-xs font-normal text-ink-muted">{data.timezone}</span>
      </p>
      <div className="mt-3 flex gap-2 overflow-x-auto pb-1" data-testid="slot-days">
        {data.days.map((d, i) => (
          <button
            key={d.date}
            type="button"
            onClick={() => setDayIdx(i)}
            className={`shrink-0 rounded-full border px-3 py-1.5 text-xs font-medium transition-colors ${
              i === dayIdx ? "border-brand bg-brand text-cream" : "border-border text-navy hover:border-sage"
            }`}
            data-testid={`slot-day-${d.date}`}
          >
            {d.label}
          </button>
        ))}
      </div>
      <div className="mt-3 grid grid-cols-3 gap-2 sm:grid-cols-4">
        {day.slots.map((s) => (
          <button
            key={s.start}
            type="button"
            onClick={() => onChange({ start: s.start, label: `${day.label} at ${s.time}` })}
            className={`rounded-xl border px-2 py-2 text-xs font-medium transition-colors ${
              value?.start === s.start ? "border-brand bg-sage-soft text-navy" : "border-border text-navy hover:border-sage"
            }`}
            data-testid={`slot-${s.start}`}
          >
            {s.time}
          </button>
        ))}
      </div>
      {value && (
        <p className="mt-3 text-xs text-brand" data-testid="slot-selected">
          Selected: {value.label} (Central Time)
        </p>
      )}
    </div>
  );
}
